import Sidemenu from "../../layout/sidemenu";
import Header from "../../layout/header";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from "react-router";
import { useState,useEffect } from "react";
import { NoAuthApiRequest,ApiRequest } from "../services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../../utils/endpoints";
import { Formik } from 'formik';
import AssignUser from "../assign-user";
import { ToastContainer, toast } from "react-toastify";
import React, { useRef } from 'react';
import Swal from "sweetalert2";
import  Loader from '../shared/loader';

const MonthlyTimesheet = () => {
      
         const usrDetails = JSON.parse(localStorage.getItem("user"));
        const [isCollapsed, setIsCollapsed] = useState(false);
        const [loader,setloader]=useState(false);
        
            const [IsAdmin,setIsAdmin]=useState(false);
             const navigate = useNavigate();
             const [lstClient,setlstClient]= useState([]);

            const [lstProject,setlstProject]= useState([]);
            const [dailyTotal,setdailyTotal] =useState(0);
            const [billableTotal,setbillableTotal] =useState(0);
            const [nonbillableTotal,setnonbillableTotal] =useState(0);
            const [estimatedHours,setestimatedHours] =useState(0);
            const [displayEstimatedHours,setdisplayEstimatedHours] =useState(false);
            const[lstTimesheet,setlstTimesheet] = useState([]);
            const [project,setProject]=useState('--Select--')
            const [category,setcategory]=useState('--select--')
            const [projectId,setprojectId]=useState('')
            const [categoryId,setcategoryId]=useState('')
            const [lstUsers,setlstUsers]= useState([]);
              const [selecteduserId,setselecteduserId]=useState('')
                                const [selecteduserName,setselecteduserName]=useState('--Select--')


         const [searchproject,setsearchproject]=useState('');
         const [searchCategory,setsearchCategory]=useState('');
         const [searchUser,setsearchUser]=useState('');
         const [currentPage, setCurrentPage] = useState(1);
         const [pageSize, setPageSize] = useState(100); // Default page size
         const [totalPages, setTotalPages] = useState(0);
        
         const [startCount, setstartCount] = useState("");
         const [endCount, setendCount] = useState("");
        const [totalCount, settotalCount] = useState("");
        const [month, setmonth] = useState("");
               const [onLoad,setonLoad]= useState(false);
const [lstCategory,setlstCategory]= useState([]);
const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
const [searchclient,setsearchclient]=useState('');

const [client,setClient]=useState('--Select--')
const [clientId,setclientId]=useState('')

        const filteredProject = lstProject.filter(user => user.Name.toLowerCase().includes(searchproject.toLowerCase()));
        const filteredcategory = lstCategory.filter(user => user.Name.toLowerCase().includes(searchCategory.toLowerCase()));
        const filteredclient = lstClient.filter(user => user.ClientName.toLowerCase().includes(searchclient.toLowerCase()));

        
           
                 const [formData, setFormData] = useState({
                    TimeSheetDate: '',
                    ProjectId:-1,
                    Title: '',
                    Description:'',
                    Billable:0,
                    NonBillable:0,
                    NoCharge:0,
                    CategoryId:-1,
                    Id:0,
                    CreatedBy:'',
                    UserId:-1
                 });
        
              
                 const filteredUser = lstUsers?.filter(user => user.Users.Name.toLowerCase().includes(searchUser.toLowerCase()));
        
                           useEffect(() => {
                                                const fetchData = async () => {
                                                    if(usrDetails?.RoleName=='admin'){
                                                        await setIsAdmin(true);
                                                        // await setselecteduserId(usrDetails?.Id);
                                                        // await setselecteduserName(usrDetails?.Name);
                                                        await setselecteduserId(-1);
                                                        await setselecteduserName('--Select--');

                                                        await FetchClient();
                                                      }
                                                    var currentDate = new Date();
                                                    var year = currentDate.getFullYear();
                                                    var month = ("0" + (currentDate.getMonth() + 1)).slice(-2); // Adding leading zero if month is single digit
                                                    var formattedDate = year + '-' + month;
                                                            
                                                    await setmonth(formattedDate)
                                                        //         await fetchTimeSheetList(formattedDate);
                                                        //  await FetchDailyTotal(formattedDate)
                                                          await FetchProject();
                                                          await FetchCategory();
                                                          await FetchUsers();
                                                              // Cleanup function to clear the timeout if the component unmounts
                                                              await setonLoad(true);
                                                             
                                                           };
                                                           fetchData();
                                                   
                                             },[]);
                                        
                                             useEffect(()=>{
                                                                         if(onLoad==true){
                                                                         
                                                     fetchTimeSheet(1,pageSize,month,projectId,selecteduserId);
                                                     FetchDailyTotal(month);
                                                                         }
                                                                 },[selecteduserId,projectId,month,categoryId,onLoad,clientId])

                                              const FetchUsers = async () => {
                                                                                                                                   
                                                                                                                                          
                                                                                         const data = await ApiRequest(
                                                                                             ApiEndpoints.User.FetchUser,
                                                                                             ApiEndpointMethod.Get,
                                                                                             null,
                                                                                             navigate
                                                                                           );
                                                                                           debugger;
                                                                                           console.log(data.Item1);
                                                                                           setlstUsers(data.Item1);
                                                                                     };

                                              const FetchCategory = async () => {
                                             
                                                    
                                                         const data = await ApiRequest(
                                                             ApiEndpoints.Entity.FetchCategory,
                                                             ApiEndpointMethod.Get,
                                                             null,
                                                             navigate
                                                           );
                                                           setlstCategory(data);
                                                     };
    
                                             const formatWeekNumber = async(weekNumber, year) =>{
                                                // Ensure week number is always two digits (e.g., 01, 02, ..., 52)
                                                if (weekNumber < 10) {
                                                    weekNumber = '0' + weekNumber;
                                                }
                                                return year + '-W' + weekNumber;
                                            }
    
                                             const  getWeekNumber= async(date) => {
                                                var d = new Date(date);
                                                d.setHours(0, 0, 0, 0);
                                                d.setDate(d.getDate() + 4 - (d.getDay() || 7)); // Set to nearest Thursday
                                                var startOfYear = new Date(d.getFullYear(), 0, 1);
                                                var weekNo = Math.ceil((( (d - startOfYear) / 86400000) + 1) / 7);
                                                return weekNo;
                                            }
    
                                            
                                             const handleChange = (e) => {
                                              const { name, value } = e.target;
                                              setFormData((prevState) => ({
                                                  ...prevState,
                                                  [name]: value
                                              }));
                                          };
                          
                                          const handleChangeTigger = (name, value) => {
                                                        setFormData((prevState) => ({
                                                         ...prevState,
                                                         [name]: value,
                                                       }));
                                                 };
                          
                          const FetchProject = async () => {
                          
                              const usrDetails = JSON.parse(localStorage.getItem("user"));
                                  const data = await ApiRequest(
                                      ApiEndpoints.Entity.FetchProjectByUser(usrDetails.Id),
                                      ApiEndpointMethod.Get,
                                      null,
                                      navigate
                                    );
                                    setlstProject(data);
                              };

                              const FetchClient = async () => {
                          
                                const usrDetails = JSON.parse(localStorage.getItem("user"));
                                    const data = await ApiRequest(
                                        ApiEndpoints.Entity.FetchClient,
                                        ApiEndpointMethod.Get,
                                        null,
                                        navigate
                                      );
                                      setlstClient(data);
                                };
                          
                              const FetchDailyTotal= async (Month) => {
                                debugger;
                                  const usrDetails = JSON.parse(localStorage.getItem("user"));
                                      const data = await ApiRequest(
                                          ApiEndpoints.TimeSheet.TotalHours((IsAdmin==true?selecteduserId:usrDetails.Id),Month,'',projectId,categoryId,clientId),
                                          ApiEndpointMethod.Get,
                                          null,
                                          navigate
                                        );
                                        setdailyTotal(data.Item1);
                                        setbillableTotal(data.Item2);
                                        setnonbillableTotal(data.Item3);
                                        setestimatedHours(data.Item4);
                                        setdisplayEstimatedHours(data.Item5);
                                  };
                          
                              // const FetchTimeEntry = async () => {
                          
                              //     const usrDetails = JSON.parse(localStorage.getItem("user"));
                              //         const data = await ApiRequest(
                              //             ApiEndpoints.Entity.FetchProjectByUser(usrDetails.Id),
                              //             ApiEndpointMethod.Get,
                              //             null,
                              //             navigate
                              //           );
                              //           setlstProject(data);
                              //     };
                          
                              const fetchTimeSheetList = async(month)=>{
                                  await fetchTimeSheet(1,pageSize,month);
                              }
                          
                              const handlePageChange = (page) => {
                                  setCurrentPage(page);
                                  fetchTimeSheet(page, pageSize);
                              };
                          
                              const getPageNumbers = () => {
                                  // Dynamically generate page numbers
                                  const pageNumbers = [];
                                  let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
                                  let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages
                                
                                  for (let i = startPage; i <= endPage; i++) {
                                      pageNumbers.push(i);
                                  }
                                  return pageNumbers;
                                };
                                  
                                          const fetchTimeSheet= async (page, limit,monthNumber='',project='',UserId='') => {
                                               
                                              try {
                                                  setloader(true);
                                                 // setLoader(true);
                                                 const usrDetails = JSON.parse(localStorage.getItem("user"));
                                 
                                                  const data = await ApiRequest(ApiEndpoints.TimeSheet.FetchTimeEntryMonth((IsAdmin==true?UserId:usrDetails.Id),page, limit,(monthNumber!=''?monthNumber:month),project,categoryId,clientId), ApiEndpointMethod.Post, null, navigate);
                                                  
                                                  
                                                  await setlstTimesheet(data.Item1);
                                                  const totalPages = Math.ceil(data.Item2 / limit);
                                                  setTotalPages(totalPages);
                                      
                                                  const startcount = Math.ceil(
                                                      Math.ceil(Math.ceil(page * limit) - limit) + 1
                                                  );
                                                  let endcount = Math.ceil(page * limit);
                                                  if (endcount > data.Item2) {
                                                      endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
                                                  }
                                                  setstartCount(startcount);
                                                  setendCount(endcount);
                                                  settotalCount(data.Item2);
                                      
                                                  return { data };
                                                  // Handle the response data here (e.g., show success message or update UI)
                                              } catch (error) {
                                                  console.error("Error during API call:", error);
                                                  // await setfileList([]);
                                                  // Handle errors (e.g., show an error message to the user)
                                              }
                                              finally {
                                               ///   setLoader(false);
                                               setloader(false);
                                              }
                                          };
                          
                                          const clear = () =>{
                                              handleChangeTigger('TimeSheetDate','');
                                      handleChangeTigger('ProjectId',-1,);
                                      handleChangeTigger('Title', '');
                                      handleChangeTigger('Description','');
                                      handleChangeTigger('Billable',0);
                                      handleChangeTigger('NonBillable',0);
                                      handleChangeTigger('NoCharge',0);
                                      handleChangeTigger('CategoryId',-1);
                                      handleChangeTigger('Id',0);
                                      handleChangeTigger('CreatedBy','');
                                      handleChangeTigger('UserId',-1);
                                          }
                          
                                          const clearformData = async() =>{
                                             await clear();
                                          }
                          
                                          const Validation = async () =>{
                                              var objvalid =true;
                                                  if(formData.TimeSheetDate=="" || formData.TimeSheetDate==null|| formData.TimeSheetDate==undefined){
                                                      toast.error("Please choose the date", {
                                                          position: "top-right",
                                                          autoClose: 3000,
                                                          hideProgressBar: false,
                                                          closeOnClick: true,
                                                          pauseOnHover: true,
                                                          draggable: true,
                                                          progress: undefined,
                                                          theme: "light",
                                                      });
                                                      objvalid=false;
                                                  }
                                                  else if(formData.ProjectId==-1){
                                                      toast.error("Please choose project", {
                                                          position: "top-right",
                                                          autoClose: 3000,
                                                          hideProgressBar: false,
                                                          closeOnClick: true,
                                                          pauseOnHover: true,
                                                          draggable: true,
                                                          progress: undefined,
                                                          theme: "light",
                                                      });
                                                      objvalid=false;
                                                  }
                                                  else if(formData.Title=="" || formData.Title==null|| formData.Title==undefined){
                                                      toast.error("Please provide the Title", {
                                                          position: "top-right",
                                                          autoClose: 3000,
                                                          hideProgressBar: false,
                                                          closeOnClick: true,
                                                          pauseOnHover: true,
                                                          draggable: true,
                                                          progress: undefined,
                                                          theme: "light",
                                                      });
                                                      objvalid=false;
                                                  }
                                                  else if(formData.Description=="" || formData.Description==null|| formData.Description==undefined){
                                                      toast.error("Please provide the detail Description", {
                                                          position: "top-right",
                                                          autoClose: 3000,
                                                          hideProgressBar: false,
                                                          closeOnClick: true,
                                                          pauseOnHover: true,
                                                          draggable: true,
                                                          progress: undefined,
                                                          theme: "light",
                                                      });
                                                      objvalid=false;
                                                  }
                                                  else if(formData.CategoryId==-1){// || formData.Description==null|| formData.Description==undefined){
                                                      toast.error("Please choose the category", {
                                                          position: "top-right",
                                                          autoClose: 3000,
                                                          hideProgressBar: false,
                                                          closeOnClick: true,
                                                          pauseOnHover: true,
                                                          draggable: true,
                                                          progress: undefined,
                                                          theme: "light",
                                                      });
                                                      objvalid=false;
                                                  }
                                                  else if(formData.Billable==0 && formData.NonBillable==0 && formData.NoCharge==0){
                                                      toast.error("Please provide the hours spend either billable or Non billable else No charge", {
                                                          position: "top-right",
                                                          autoClose: 3000,
                                                          hideProgressBar: false,
                                                          closeOnClick: true,
                                                          pauseOnHover: true,
                                                          draggable: true,
                                                          progress: undefined,
                                                          theme: "light",
                                                      });
                                                      objvalid=false;
                                                  }
                                                  return objvalid;
                                          }
                          
                                          const EditTimeSheet = async(TimeSheetId) => {
                                              setloader(true);
                                              const data = await ApiRequest(ApiEndpoints.TimeSheet.EditTimeSheet(TimeSheetId), ApiEndpointMethod.Get, null,navigate);
                                              if(data != null){
                                                  handleChangeTigger('TimeSheetDate',data.TimeSheetDate.split('T')[0]);
                                                  handleChangeTigger('ProjectId',data.ProjectId);
                                                  handleChangeTigger('Title', data.Title);
                                                  handleChangeTigger('Description',data.Description);
                                                  handleChangeTigger('Billable',data.Billable);
                                                   handleChangeTigger('NonBillable',data.NonBillable);
                                                  handleChangeTigger('NoCharge',data.NoCharge);
                                                  handleChangeTigger('CategoryId',data.CategoryId);
                                                  handleChangeTigger('Id',data.Id);
                                                  handleChangeTigger('CreatedBy',data.CreatedBy);
                                                  handleChangeTigger('UserId',data.UserId);
                                                  setloader(false);
                                              }
                                          }
                          
                                          const DeleteTimeEntry = async(TimeSheetId) => {
                                              const result = await Swal.fire({
                                                  title: '',
                                                  text:  "Are you sure want to delete the time entry?",
                                                  icon: "warning",
                                                  showCancelButton: true,
                                                  confirmButtonText: "Yes",
                                                  cancelButtonText: "No",
                                                  reverseButtons: true,
                                                });
                                                if (result.isConfirmed) {
                                                  setloader(true);
                                                  const data = await ApiRequest(ApiEndpoints.TimeSheet.DeleteTimeEntry(TimeSheetId), ApiEndpointMethod.Get, null,navigate);
                                                  if(data != null){
                                                      await clear();
                                                                   toast.success("Time entry deleted successful", {
                                                                       position: "top-right",
                                                                       autoClose: 3000,
                                                                       hideProgressBar: false,
                                                                       closeOnClick: true,
                                                                       pauseOnHover: true,
                                                                       draggable: true,
                                                                       progress: undefined,
                                                                       theme: "light",
                                                                   });
                                                                   fetchTimeSheet(currentPage, pageSize);
                                                  }
                                                  setloader(false);
                                                }
                                          }
                          
                           const CreateTimeSheet = async () => {
                              try{
                                  var objvalid =  await Validation();
                                  if(objvalid==true){
                                      setloader(true);
                                  const usrDetails = JSON.parse(localStorage.getItem("user"));
                                  formData.UserId=usrDetails.Id;
                                    const data = await ApiRequest(ApiEndpoints.TimeSheet.CreateTimeEntry, ApiEndpointMethod.Post, formData,navigate);
                               
                                  if(data.success==true){
                                      await clear();
                                                                   toast.success(data.message, {
                                                                       position: "top-right",
                                                                       autoClose: 3000,
                                                                       hideProgressBar: false,
                                                                       closeOnClick: true,
                                                                       pauseOnHover: true,
                                                                       draggable: true,
                                                                       progress: undefined,
                                                                       theme: "light",
                                                                   });
                                                                   fetchTimeSheet(currentPage, pageSize);
                                                               }
                                                               else{
                                                                 
                                                                  await clear();
                                                                   toast.error(data.message, {
                                                                       position: "top-right",
                                                                       autoClose: 3000,
                                                                       hideProgressBar: false,
                                                                       closeOnClick: true,
                                                                       pauseOnHover: true,
                                                                       draggable: true,
                                                                       progress: undefined,
                                                                       theme: "light",
                                                                   });
                                                               }
                                  }
                          
                              } catch (error) {
                                              // Handle network errors or any other errors
                                              console.error("There was an error sending the form data", error);
                                              toast.success(error, {
                                                  position: "top-right",
                                                  autoClose: 3000,
                                                  hideProgressBar: false,
                                                  closeOnClick: true,
                                                  pauseOnHover: true,
                                                  draggable: true,
                                                  progress: undefined,
                                                  theme: "light",
                                              });
                                          }
                                          finally {
                                              setloader(false);
                                          }
                             };
        
                             const handleChangeValue = async (e) => {
                            setmonth(e.target.value);
                              // await fetchTimeSheetList(e.target.value);
                                await FetchDailyTotal(e.target.value);
                                                         
                            };
    
        
                            const formatDateUTCDate = (dateString) => {
                                const date = new Date(dateString);
                            
                                // Adjust to local time
                                const month = date.getMonth() + 1; // Months are zero-indexed
                                const day = date.getDate();
                                const year = date.getFullYear();
                            
                                return `${month}/${day}/${year}`;
                            }
                
                            const ProjectSet =async(Id,Name) =>{
                                setprojectId(Id);
                                setProject(Name);
                                // await fetchTimeSheet(1,pageSize,month,Id);
                            }

                            const ClientSet =async(Id,Name) =>{
                                setclientId(Id);
                                setClient(Name);
                                // await fetchTimeSheet(1,pageSize,month,Id);
                                if(Id>0){
                                 await FetchProjectList(Id);
                                }
                                else{
                                    await FetchProject();
                                    await ProjectSet('','--Select--')
                                }
                            }

                            const FetchProjectList =async(Id)=>{
                                    //FetchProjectByClient
                                    const data = await ApiRequest(ApiEndpoints.Entity.FetchProjectByClient(Id), ApiEndpointMethod.Get, null, navigate);
                                    setlstProject(data);         
                           
                                }

                            const CategorySet =async(Id,Name) =>{
                                setcategoryId(Id);
                                setcategory(Name);
                            }

                            const UsersSet= async(Id,Name)=> {
                                await setselecteduserId(Id);
                                await setselecteduserName(Name);
                                //await fetchTimeSheet(1,pageSize,month,projectId,Id);
                        }
                        
                        const getSortIcon = (key) => {
                            if (sortConfig.key !== key) return <i className="fas fa-sort"></i>;
                            return sortConfig.direction === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>;
                          };

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                                <h5 className="mb-0 me-2">Monthly Timesheet</h5>
                                <div className="heading-badge"><small>Total Hours:</small>{dailyTotal} Hrs</div>
                                <div className="heading-badge" style={{marginLeft:"5px"}}><small>Billable Hours:</small>{billableTotal} Hrs</div>
                                <div className="heading-badge" style={{marginLeft:"5px"}}><small>Non billable Hours:</small>{nonbillableTotal} Hrs</div>
                                {displayEstimatedHours && (
                                <div  className="heading-badge" style={{marginLeft:"5px"}}><small>Estimated Hours:</small>{estimatedHours} Hrs</div>
                                )}
                            </div>
                            <div>
                                <div className="dropdown">
                                    <button className="btn btn-sm btn-outline-info dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fas fa-file-export me-1"></i>Export
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href="#">Excel</a></li>
                                        <li><a className="dropdown-item" href="#">PDF</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="">
                            <div className="row mb-2">
                                <div class="col-lg-2">
                                <span>Month</span>
                                <input className="form-control form-control-sm me-2" type="month"
                                onChange={handleChangeValue} value={month} />
                                </div>
                                {IsAdmin ==true && (
                                      <div class="col-lg-2">
                                      <label className="">Client:</label>
                                      <input type="text" className="btn btn-sm btn-filter form-control" data-bs-toggle="dropdown"
                                       aria-expanded="false" value={client} style={{textAlign:"left"}}/>
                                      <ul className="dropdown-menu" value={clientId} style={{height:"50vh",overflowY:"scroll"}}>
                                       <input type="text" className="form-control" onChange={(e) =>
                                                      setsearchclient(
                                                        e.target.value
                                                      )
                                                    }/>
                                         <li>
                                          <a class="dropdown-item" onClick={()=>{ClientSet('','--Select--')}} value={'0'}>--Select--</a>
                                          </li> 
                                          {filteredclient?.map((proj) => (
                                          <li>
                                              <a class="dropdown-item" value={proj.Id} onClick={()=>{ClientSet(proj.Id,proj.ClientName)}}> {proj.ClientName}</a>
                                          </li>
                                          ))}
                                      </ul>
                                  </div>
                                     )}
                                <div class="col-lg-2">
                                    <label className="">Project:</label>
                                    {/* <span className="fw-semibold">{project}</span> */}
                                    <input type="text" className="btn btn-sm btn-filter form-control" data-bs-toggle="dropdown"
                                     aria-expanded="false" value={project} style={{textAlign:"left"}}/>
                                    <ul className="dropdown-menu" value={projectId} style={{height:"50vh",overflowY:"scroll"}}>
                                     <input type="text" className="form-control" onChange={(e) =>
                                                    setsearchproject(
                                                      e.target.value
                                                    )
                                                  }/>
                                       <li>
                                        <a class="dropdown-item" onClick={()=>{ProjectSet('','--Select--')}} value={''}>--Select--</a></li> 
                                        {filteredProject?.map((proj) => (
                                        <li>
                                            <a class="dropdown-item" value={proj.Id} onClick={()=>{ProjectSet(proj.Id,proj.Name)}}> {proj.Name}</a>
                                        </li>
                                        ))}
                                    </ul>
                                    {/* <button class="btn btn-sm btn-filter" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="me-2">Project:</span><span className="fw-semibold">{project}</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" onClick={()=>{ProjectSet('','All')}} value={''}>All</a></li> 
                                    {lstProject?.map((proj) => (
                                        <li>
                                            <a class="dropdown-item" onClick={()=>{ProjectSet(proj.Id,proj.Name)}}
                                               value={proj.Id}>
                                                 {proj.Name}
                                               </a>
                                        </li>
                                    ))}
                                    </ul> */}
                                </div>
                                <div class="col-lg-2">
                                   <label className="">Category:</label>
                                    {/* <span className="fw-semibold">{project}</span> */}
                                    <input type="text" className="btn btn-sm btn-filter form-control" data-bs-toggle="dropdown"
                                     aria-expanded="false" value={category} style={{textAlign:"left"}}/>
                                    <ul className="dropdown-menu" value={categoryId} style={{height:"50vh",overflowY:"scroll"}}>
                                       <input type="text" className="form-control" onChange={(e) =>
                                                    setsearchCategory(
                                                      e.target.value
                                                    )
                                                  }/>
                                        <li><a  onClick={()=>{CategorySet('','--Select--')}} value={''} class="dropdown-item">--Select--</a></li> 
                                          {filteredcategory?.map((proj) => (
                                                    <li><a class="dropdown-item" onClick={()=>{CategorySet(proj.Id,proj.Name)}} value={proj.Id}>{proj.Name}</a></li> 
                                                ))}
                                    </ul>
                                    {/* <button class="btn btn-sm btn-filter" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="me-2">Category:</span><span className="fw-semibold">{category}</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li><a class="dropdown-item" onClick={()=>{CategorySet('','All')}} value={-1}>All</a></li> 
                                        {lstCategory?.map((proj) => (
                                                    // <option value={proj.Id}>
                                                    //         {proj.Name}
                                                    // </option>
                                                    <li><a class="dropdown-item" onClick={()=>{CategorySet(proj.Id,proj.Name)}} value={proj.Id}>{proj.Name}</a></li> 
                                      
                                                ))}
                                      </ul> */}
                                </div>
                                {IsAdmin ==true && (
                                            
                                            
                                <div class="col-lg-2">
                                     <label className="">User:</label>
                                    <input type="text" className="btn btn-sm btn-filter form-control" data-bs-toggle="dropdown"
                                     aria-expanded="false" value={selecteduserName} style={{textAlign:"left"}}/>
                                    <ul className="dropdown-menu" value={selecteduserId} style={{height:"50vh",overflowY:"scroll"}}>
                                       <input type="text" className="form-control" onChange={(e) =>
                                                    setsearchUser(
                                                      e.target.value
                                                    )
                                                  }/>
                                         <li><a class="dropdown-item" onClick={()=>{UsersSet('','--Select--')}} value={-1}>--Select--</a></li> 
                                            {filteredUser.map((proj) => (
                                                    <li><a class="dropdown-item" onClick={()=>{UsersSet(proj.Users.Id,proj.Users.Name)}} value={proj.Users.Id}>{proj.Users.Name}</a></li> 
                                      
                                                ))}
                                    </ul>

                                    {/* <button class="btn btn-sm btn-filter" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="me-2">Users:</span><span className="fw-semibold">{selecteduserName}</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" onClick={()=>{UsersSet('','All')}} value={-1}>All</a></li> 
                                    {lstUsers?.map((proj) => (
                                                    <li><a class="dropdown-item" onClick={()=>{UsersSet(proj.Users.Id,proj.Users.Name)}} value={proj.Users.Id}>{proj.Users.Name}</a></li> 
                                      
                                                ))}
                                      </ul>  */}
                                </div>
                                
                                )}
                                 {/* <div class="col-lg-3">
                                <label className="hide"></label>
                                <input className="form-control form-control-sm" placeholder="search..." type="search" />
                            </div> */}
                            </div>
                           
                        </div>

                        <div className="table-wrapper weekly-table">
                            <table className="table table-striped table-bordered bg-white align-middle mb-0">
                                <thead>
                                    <tr>
                                       {IsAdmin ==true && (
                                            
                                            <th width="12%">
                                                User Name <a className="float-end text-muted">{getSortIcon('name')}</a>
                                            </th>
                                           
                                           )}
                                        <th width="8%">Date</th>
                                        <th width="13%">Project Name</th>
                                        <th width="9%">Category</th>
                                        <th width="7%" className="text-center">Billable Hours</th>
                                        <th width="8%" className="text-center">Non Billable Hours</th>
                                        <th width="8%" className="text-center">No Charge Hours</th>
                                        <th width="12%">Task Title</th>
                                        <th width="27%">Description</th>
                                        {/* <th width="8%" className="text-center">Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                {lstTimesheet?.map((time) => (
                                    <tr>
                                         {IsAdmin ==true && (
                                            
                                            <td>{time.User}</td>
                                           
                                        )}
                                         <td>{formatDateUTCDate(time.TimeSheetDate)}</td>
                                        <td>
                                            <div>{time.Project}</div>
                                            <small className="fst-italic text-muted">{time.Client}</small>
                                        </td>
                                        <td>{time.Category}</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>{time.Billable}</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>{time.NonBillable}</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>{time.NoCharge}</td>
                                        <td>{time.Title}</td>
                                        <td> <span className="text-ellipsis">{time.Description}</span></td>
                                        {/* <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit" onClick={()=>EditTimeSheet(time.Id)}>
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete" onClick={()=>DeleteTimeEntry(time.Id)}>
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td> */}
                                    </tr>
                                ))}
                                    {/* <tr>
                                        <td>01/03/2025</td>
                                        <td>
                                            <div>Amalga</div>
                                            <small className="fst-italic text-muted">Kevin M. Dorey</small>
                                        </td>
                                        <td>Development</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>2:00</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>2:00</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>2:00</td>
                                        <td></td>
                                        <td></td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                        <div className="pagination-wrapper shadow-sm">
                               <p className="mb-0 me-2">{startCount} - {endCount} of {totalCount}</p>
                               <ul className="pagination">
                                   <li className={`pagination-previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                                           <i className="fa-solid fa-chevron-left"></i>
                                       </a>
                                   </li>

                                   {getPageNumbers().map((page) => (
                                       <li key={page} >
                                           <a className={page === currentPage ? 'active' : ''} onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                               {page}
                                           </a>
                                       </li>
                                   ))}

                                   <li className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage < totalPages) handlePageChange(currentPage + 1); }}>
                                           <i className="fa-solid fa-chevron-right"></i>
                                       </a>
                                   </li>
                               </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            {loader && (
                <Loader/>
            )}
        </>
    )
}

export default MonthlyTimesheet;